import algoliasearch, { SearchIndex } from 'algoliasearch';
import 'firebase/compat/firestore';
import { ArtistSearchResult, SongSearchResult } from '../data/store/useSearch';
import { ARTIST_INDEX, SONG_INDEX } from '../config/env';
import { Artist } from '../models/Artist';
import { Song, SongId } from '../models/Song';



  //school of song artist-instructor
  //rc song share
  //songaday net dev
  //school of song dev


interface ArtistSearchProps {
  nbPages: number;
  artists: ArtistSearchResult[];
}

interface SongSearchProps {
  nbPages: number;
  songs: SongSearchResult[];
}

interface MultiSearchProps {
  nbPages: number;
  artists: ArtistSearchResult[];
  songs: SongSearchResult[];
}

export class SearchService {
  private static instance: SearchService;
  private algolia = algoliasearch('ZL63XIDYO3', 'ac2ff020aed198f0aed5dc09b76b9f55');
  private artists: SearchIndex;
  private songs: SearchIndex;

  private constructor() {
    this.artists = this.algolia.initIndex(ARTIST_INDEX)
    this.songs = this.algolia.initIndex(SONG_INDEX)
  }

  public static please(): SearchService {
    if (!SearchService.instance)
      SearchService.instance = new SearchService();
    return SearchService.instance;
  }


  search(query: string): Promise<ArtistSearchResult[]> {
    return new Promise((resolve, reject) => {
      this.artists.search(query).then(({ hits }) => {
        console.log(hits);
        const artistRefs = hits.map(x => x as unknown as ArtistSearchResult)
        if (artistRefs.length !== 0) {
          resolve(artistRefs);
        }
      }).catch(reject);
    })
  }

  searchArtists(query: string, page: number): Promise<ArtistSearchProps> {
    console.log('[SearchService] searchArtists', { query, page, index: ARTIST_INDEX });
    return new Promise((resolve, reject) => {
      this.artists.search(query, {
        page,
      }).then(({ hits, nbPages }) => {
        console.log('[SearchService] searchArtists hits', { count: hits.length, nbPages });
        const artistRefs = hits.map(x => x as unknown as ArtistSearchResult)
        resolve({ nbPages, artists: artistRefs });
      }).catch((err) => {
        console.error('[SearchService] searchArtists error', err);
        reject(err);
      });
    })
  }

  searchSongs(query: string, page: number): Promise<SongSearchProps> {
    console.log('[SearchService] searchSongs', { query, page, index: SONG_INDEX });
    return new Promise((resolve, reject) => {
      this.songs.search(query, {
        page,
      }).then(({ hits, nbPages }) => {
        console.log('[SearchService] searchSongs hits', { count: hits.length, nbPages });
        const songRefs = hits.map(x => (x as any) as SongSearchResult);
        resolve({ nbPages, songs: songRefs });
      }).catch((err) => {
        console.error('[SearchService] searchSongs error', err);
        reject(err);
      });
    })
  }

  searchMulti(query: string, page: number): Promise<MultiSearchProps> {
    return new Promise((resolve, reject) => {
      const queries = [{
        indexName: ARTIST_INDEX,
        query: query,
        params: {
          hitsPerPage: 1000,
        }
      }, {
        indexName: SONG_INDEX,
        query: query,
        params: {
          page,
        }
      }];
      console.log('[SearchService] searchMulti', { query, page, ARTIST_INDEX, SONG_INDEX });
      this.algolia.search(queries).then(({ results }) => {
        const artistsResult:any = results.find((result:any) => result.index === ARTIST_INDEX);
        const songsResult:any = results.find((result:any) => result.index === SONG_INDEX);
        const artists = artistsResult ? artistsResult.hits.map((x:any) => (x as any) as ArtistSearchResult) : [];
        const songs = songsResult ? songsResult.hits.map((x:any )=> (x as any) as SongSearchResult) : [];
        const nbPages = songsResult ? songsResult.nbPages : 0;
        console.log('[SearchService] searchMulti results', { artists: artists.length, songs: songs.length, nbPages });
        resolve({
          nbPages,
          artists,
          songs,
        });
      }).catch((err) => {
        console.error('[SearchService] searchMulti error', err);
        reject(err);
      });
    })
  }

  pushArtistToIndex(artist: Artist) {
    const { id, alias, avatar } = artist
    if (alias.includes('https://')) {
      return;
    }
    console.log('add artist to search index' + artist.alias);
    this.artists.saveObject({ id, alias, avatar,  objectID: id });
  }

  pushSongToIndex(song: Song) {
    const { id, title, authors } = song
    const artists = authors.map(x => song.artists[x]);
    this.songs.saveObject({ id, title, artists, objectID: id });
  }

  removeSongFromIndex(id: SongId) {
    this.songs.deleteObject(id);
  }

  pushArtistBatchToIndex(artists: Array<{ id: string; alias: string; avatar?: string }>) {
    const objects = artists
      .filter((a) => a.alias && !a.alias.includes('https://'))
      .map((a) => ({
        id: a.id,
        alias: a.alias,
        avatar: a.avatar || '',
        objectID: a.id,
      }));
    if (objects.length === 0) return Promise.resolve({ skipped: artists.length, written: 0 });
    return this.artists.saveObjects(objects).then(() => ({
      skipped: artists.length - objects.length,
      written: objects.length,
    }));
  }

  pushSongBatchToIndex(songs: Array<{ id: string; title: string; authors?: string[]; artists?: any }>) {
    const objects = songs
      .filter((s) => !!s.title)
      .map((s) => {
        const authors = s.authors || [];
        const artistsMap = s.artists || {};
        const artists = authors.map((a) => artistsMap[a]).filter(Boolean);
        return {
          id: s.id,
          title: s.title,
          artists,
          objectID: s.id,
        };
      });
    if (objects.length === 0) return Promise.resolve({ skipped: songs.length, written: 0 });
    return this.songs.saveObjects(objects).then(() => ({
      skipped: songs.length - objects.length,
      written: objects.length,
    }));
  }
}
